// analytics/eventBufferSingleton.js

import createEventBuffer from "./useCdpQueue";

const eventBuffer = createEventBuffer({
  maxBatch: 15,
  flushInterval: 15000,
  storageKey: "eventBufferQueue",
  backendUrl: `${process.env.NEXT_PUBLIC_R2_CLIENT_API_GATEWAY}/event/v1/track/batch`,
  lockName: "eventBufferLeaderLock",
});

export default eventBuffer;
